import React from "react";
import styled from "@emotion/styled";
import { BaseExercise } from "@domain/exercise/exercise";
import { Stepper } from "@ui/components/buttons/stepper";
import { AlternativeExerciseOptions } from "@ui/pages/program-builder/alternative-exercise/alternative-exercise-options";

export const AlternativeExerciseFooterOptions: React.FC<{
	alternatives: BaseExercise[];
	alternativeExercise: BaseExercise;
	alternativeExerciseIndex: number;
	relatedExercises: BaseExercise[];
	onDelete: (exercise: BaseExercise) => void;
	onReorder?: (sourceAlternativeExerciseIndex: number, destinationAlternativeExerciseIndex: number) => void;
}> = ({ alternatives, alternativeExercise, alternativeExerciseIndex, relatedExercises, onDelete, onReorder }) => {
	const handleMoveUp = () => {
		onReorder?.(alternativeExerciseIndex, alternativeExerciseIndex - 1);
	};

	const handleMoveDown = () => {
		onReorder?.(alternativeExerciseIndex, alternativeExerciseIndex + 1);
	};

	return (
		<Container>
			<Stepper
				onMoveUp={handleMoveUp}
				onMoveDown={handleMoveDown}
				min={0}
				max={alternatives.length - 1}
				value={alternativeExerciseIndex}
			/>
			<AlternativeExerciseOptions
				alternativeExercise={alternativeExercise}
				onDelete={onDelete}
				relatedExercises={relatedExercises}
			/>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	justify-content: space-between;
	margin: -4px -4px -8px 16px;

	> svg {
		cursor: pointer;
	}
`;
